import React from 'react';
import ListarDepositos from '../../../components/insumos/depositos/ListarDepositos';

const DepositosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <ListarDepositos />
    </div>
  );
};

export default DepositosPage;